document.addEventListener('click', (e) => {
  const a = e.target.closest('.frame-left .nav-item > a');
  if (!a) return;
  if (a.dataset.toggle === 'true') {
    e.preventDefault();
    const li = a.parentElement;
    li.classList.toggle('open');
  }
}, {passive:false});
